import React, { Component } from 'react'
import { isBrowser } from 'react-device-detect'
import ReactFullpage from '@fullpage/react-fullpage'
import Header from '../../Header'
import Content from "./Content";

class Persona extends React.Component {
  constructor(props) {
    super(props);
  }

  pluginWrapper = () => {
    require('fullpage.js/vendors/scrolloverflow');
  };

  render() {
    const { currentUser, persona, can_unlock } = this.props;
    console.log(persona)
    const licenseKey = '26CA2A3F-7CBD4D76-8332EDE8-2794057D';
    const tooltips = {
      navigation: [
        'Universe',
        'Overview',
        ...(persona.locations.some(location => ['region', 'continent'].includes(location.type)) ? ['Breakdown by countries'] : []),
        'Breakdown by cities',
        'Breakdown by professions',
        'Emotions Associated with the category',
        'Days Of Week',
        'The Essentials',
        'The Essentials - Interests',
        ...(persona.locations.some(location => location.type === 'city') ? ['The Essentials - Locations'] : []),
        'Getting more Specific',
        'Content Creators Relevant To Your Category',
        'Content: When & What ?',
        'Content: When & What ?',
        'Top Phrases',
        'Content they search for',
        'Content they are exposed',
        'Did you know?',
        'What should you do with this information?',
        'Media touch points',
        'Content Strategy',
        'Content Pillar Strategy',
        'Content Pillar Strategy'
      ]
    };

    const content = (
      <Content {...this.props}/>
    );

    return (
      <React.Fragment>
        <Header
          personaName={persona.name}
          personaId={persona.id}
          canUnlock={can_unlock}
          buttonText={persona.payed && 'Generate Persona' || `Purchase`}
          buttonUrl={persona.payed && '/personas/new' || `/pricing`}
          currentUser={currentUser}
          limitedView={!persona.payed}
          payed={persona.payed}
          showPrintBtn
        />

        {
          isBrowser && (
            <ReactFullpage
              licenseKey={licenseKey}
              navigation
              navigationTooltips={tooltips.navigation}
              pluginWrapper={this.pluginWrapper}
              scrollOverflow
              render={({ state, fullpageApi }) => {
                return (
                  <ReactFullpage.Wrapper>
                    {content}
                  </ReactFullpage.Wrapper>
                );
              }}
            />
          )
          || content
        }
      </React.Fragment>
    )
  }
}

export default Persona
